import styled from "@emotion/styled";

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;
